import { Injectable } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class TemperatureService {
  private readonly APP_WIDE_KEY = 'app_temperature_unit';
  constructor(private storage: StorageService) { }

  celsiusToFahrenheit(c: number): number {
    return (c * 9 / 5) + 32;
  }

  fahrenheitToCelsius(f: number): number {
    return (f - 32) * 5 / 9;
  }

  async getTemperatureUnit(): Promise<'celsius' | 'fahrenheit'> {
    try {
      const raw = await this.storage.get(this.APP_WIDE_KEY);
      const parsed = JSON.parse(raw || '""');
      const cleanUnit = parsed?.toString()?.trim().toLowerCase() || 'celsius';

      console.log('Parsed→Clean:', parsed, '→', cleanUnit);
      return cleanUnit === 'fahrenheit' ? 'fahrenheit' : 'celsius';
    } catch {
      return 'celsius';
    }
  }

  async setTemperatureUnit(unit: 'celsius' | 'fahrenheit') {
    await this.storage.set(this.APP_WIDE_KEY, unit);
  }
}